<template>
  <div class="mpay">
    <img src="../../../../assets/mpay.png"
         alt="" />
    <div class="mpay_text">MPay支付頁（由MPay提供）</div>
    <el-button type="warning"
               @click="$router.push('/drivingPaymentResult')">立即支付</el-button>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.mpay {
  width: 500px;
  margin: 0 auto;
  padding-top: 200px;
  text-align: center;
  font-size: 30px;
  /deep/.el-button {
    font-size: 24px;
    width: 350px;
    padding: 15px;
  }
  /deep/.el-button--warning {
    background-color: #f59b23;
    border-color: #f59b23;
  }
}
.mpay_text {
  margin-bottom: 50px;
}
.mpay img {
  margin-bottom: 50px;
}
</style>